import { action, computed, debug, NetbankingAPI, observable } from "aaa";
import { NetbankingAPIClient } from "network/APIClient";
import { CardStore } from "stores/CardStore";
import { ISignInfoResponse } from "types/signing";

export class ActivateCardStore {
    cardStore = new CardStore();

    @observable isLoadingActivation = false;
    response?: ISignInfoResponse;

    @computed get isLoading(): boolean {
        return this.cardStore.isLoading;
    }

    @action async load(cardId: string) {
        await Promise.all([
            this.cardStore.loadCard(cardId),
        ]);
    }

    @action async activateCard() {
        if (!this.cardStore.card) {
            return;
        }

        try {
            this.isLoadingActivation = true;
            const target = NetbankingAPI.postActivate(this.cardStore.card.id);
            this.response = await NetbankingAPIClient.requestType(target);
            debug.log("### activateCard", this.response);
            this.isLoadingActivation = false;
        } catch (error) {
            this.isLoadingActivation = false;
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/activateCard/ActivateCardStore.tsx